const angular = require('angular');

const { fulfilmentSelectorDialogComponentDefinition } = require('./fulfilment-selector-dialog.component');
const { fulfilmentSelectorDialogContentComponentDefinition } = require('./fulfilment-selector-dialog-content.component');
const { fulfilmentSelectorDeliveryPickupComponentDefinition } = require('./fulfilment-selector-delivery-pickup.component');
const { fulfilmentSelectorPickupAddressComponentDefinition } = require('./fulfilment-selector-pickup-address.component');
const { fulfilmentSelectorDeliveryAddressComponentDefinition } = require('./fulfilment-selector-delivery-address.component');
const { fulfilmentSelectorSelectedAddressComponentDefinition } = require('./fulfilment-selector-selected-address.component');
const { fulfilmentSelectorManualAddressComponentDefinition } = require('./fulfilment-selector-manual-address.component');
const fulfilmentSelectorService = require('./fulfilment-selector.service');

angular.module('wowApp.fulfilment')
    .service('FulfilmentSelectorService', fulfilmentSelectorService)
    .component('wowFulfilmentSelectorDialog', fulfilmentSelectorDialogComponentDefinition)
    .component('wowFulfilmentSelectorDialogContent', fulfilmentSelectorDialogContentComponentDefinition)
    .component('wowFulfilmentSelectorDeliveryPickup', fulfilmentSelectorDeliveryPickupComponentDefinition)
    .component('wowFulfilmentSelectorPickupAddress', fulfilmentSelectorPickupAddressComponentDefinition)
    .component('wowFulfilmentSelectorDeliveryAddress', fulfilmentSelectorDeliveryAddressComponentDefinition)
    .component('wowFulfilmentSelectorSelectedAddress', fulfilmentSelectorSelectedAddressComponentDefinition)
    .component('wowFulfilmentSelectorManualAddress', fulfilmentSelectorManualAddressComponentDefinition);




// WEBPACK FOOTER //
// ./src/fulfilment/fulfilmentselector/index.js